import { render } from "./TipoViagem.vue?vue&type=template&id=2c00791c&scoped=true"
import script from "./TipoViagem.vue?vue&type=script&lang=js"
export * from "./TipoViagem.vue?vue&type=script&lang=js"

import "./TipoViagem.vue?vue&type=style&index=0&id=2c00791c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c00791c"]])

export default __exports__